import { type DropEvent } from 'react-dropzone';

import { WORKSPACE_CANVAS_HORIZONTAL_PADDING, WORKSPACE_MIN_WIDTH } from '~/constants/panelWidths';

/** Mirrors WorkspaceRightPanel width so drag/drop can tell canvas vs workspace apart. */
export function isPointOverCanvasRightPanel(clientX: number): boolean {
  const storedWidth = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--right-sidebar-width') || '0',
    10,
  );
  const leftNavWidth = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--left-nav-width') || '0',
    10,
  );
  const rightPanelWidth = Math.min(
    storedWidth,
    window.innerWidth - leftNavWidth - WORKSPACE_MIN_WIDTH - WORKSPACE_CANVAS_HORIZONTAL_PADDING,
  );

  return clientX > window.innerWidth - rightPanelWidth;
}

export function getDropClientCoordinates(event: DropEvent | null): { x: number; y: number } | null {
  if (event && 'clientX' in event && typeof event.clientX === 'number' && typeof event.clientY === 'number') {
    return { x: event.clientX, y: event.clientY };
  }

  return null;
}
